import React from 'react';
import strings from '../../utils/strings';

const Mark: React.FC = ({ children }) => <mark className="search-mark">{children}</mark>;

interface Props {
  text: string;
  search: string;
  searchCriteria: 'startsWith' | 'anywhere';
}

const SearchHighlight: React.FC<Props> = ({ text, search, searchCriteria }) => {
  if (!search) return <>{text}</>;

  let highlightedText;
  if (searchCriteria === 'startsWith') {
    highlightedText = (
      <>
        <Mark>{text.substr(0, search.length)}</Mark>
        {text.substr(search.length)}
      </>
    );
  } else {
    const index = strings.normalize(text).search(strings.normalize(search));
    highlightedText = (
      <>
        {text.substr(0, index)}
        <Mark>{text.substr(index, search.length)}</Mark>
        {text.substr(index + search.length)}
      </>
    );
  }
  return highlightedText;
};

export default SearchHighlight;
